import uuidV4 from 'lib/string/uuidV4Utils'
import type { CreateReviewOkResponse, FetchReviewsOkResponse, UpdateReviewOKResponse } from 'api/review'

type ReviewResponse =
  | FetchReviewsOkResponse['result'][number]
  | CreateReviewOkResponse['result']
  | UpdateReviewOKResponse['result']

type TranslationsOf<T> = T extends { translations?: infer TTranslations } ? TTranslations : never
type ReviewTranslationsResponse = TranslationsOf<ReviewResponse> | undefined

function nullToUndefined<T>(value: T | null | undefined): T | undefined {
  return value ?? undefined
}

function mapReviewTranslations(translations: ReviewTranslationsResponse): App.Review['translations'] {
  const translatedReview = nullToUndefined(translations?.review)

  if (!translatedReview) return undefined

  return {
    review: {
      text: nullToUndefined(translatedReview.text),
      sourceLanguage: nullToUndefined(translatedReview.sourceLanguage),
      targetLanguage: nullToUndefined(translatedReview.targetLanguage),
      machineTranslated: nullToUndefined(translatedReview.machineTranslated),
    },
  }
}

export function mapUserReview(review: ReviewResponse): App.Review {
  return {
    id: review.id || uuidV4(),
    rating: review.rating,
    review: nullToUndefined(review.review),
    improvementSuggestion: nullToUndefined(review.improvementSuggestion),
    companionship: nullToUndefined(review.companionship),
    definition: nullToUndefined(review.definition),
    staffRating: nullToUndefined(review.staffRating),
    facilitiesRating: nullToUndefined(review.facilitiesRating),
    valueRating: nullToUndefined(review.valueRating),
    locationRating: nullToUndefined(review.locationRating),
    accommodationRating: nullToUndefined(review.accommodationRating),
    nps: nullToUndefined(review.nps),
    howImprove: nullToUndefined(review.howImprove),
    bestCompanyAreas: nullToUndefined(review.bestCompanyAreas),
    userId: nullToUndefined(review.userId),
    orderId: nullToUndefined(review.orderId),
    offerId: nullToUndefined(review.offerId),
    propertyId: nullToUndefined(review.propertyId),
    experienceId: nullToUndefined(review.experienceId),
    tourId: nullToUndefined(review.tourId),
    userName: review.userName,
    userCountry: nullToUndefined(review.userCountry),
    source: review.source,
    tourBrand: nullToUndefined(review.tourBrand),
    isPubliclyVisible: nullToUndefined(review.isPubliclyVisible),
    offerPackageName: nullToUndefined(review.offerPackageName),
    offerRoomName: nullToUndefined(review.offerRoomName),
    orderNumberOfNights: nullToUndefined(review.orderNumberOfNights),
    reservationCheckinDate: nullToUndefined(review.reservationCheckinDate),
    createdAt: review.createdAt,
    updatedAt: nullToUndefined(review.updatedAt),
    userOrdersCount: 'userOrdersCount' in review ? nullToUndefined(review.userOrdersCount) : undefined,
    userReviewsCount: 'userReviewsCount' in review ? nullToUndefined(review.userReviewsCount) : undefined,
    photos: nullToUndefined(review.photos),
    response: nullToUndefined(review.response),
    translations: 'translations' in review ? mapReviewTranslations(review.translations) : undefined,
  }
}
